import * as React from 'react';
import { DateFilter, DropdownValue } from '../DateFilter';
import { Loader } from '../Loader';
import { injectIntl, useIntl } from 'react-intl';
import { TranslateText } from '../TranslateText';
import { HintMessage } from '../HintMessage';
import { XYLineChartWidget } from '../XYLineChartWidget';

// Typescript definition
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
;

// Trend Widget component with props and its types
const _TrendWidget = props => {
  const {
    loader,
    title,
    value,
    previousValue,
    text,
    dateFilterTitle,
    dateFilter,
    dateFilterOptions,
    dateFilterValue,
    onTriggerDateFilterChange,
    dateFilterDateFormat,
    message,
    noValueText,
    width,
    disabled,
    showHintMessage,
    hintMessage,
    chartData,
    legend
  } = props;
  const trendValue = previousValue?.label ? value.value === previousValue.value ? '' : value.value > previousValue.value ? 'high' : 'low' : '';
  const intl = useIntl();
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: `kc-ui-colm kc-ui-trend ${disabled && "kc-ui-disabled "}  ${loader && "kc-ui-loader-overlay"}`,
      style: {
        width: `${width}`
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "kc-ui-colm-div",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "kc-ui-title-div",
          children: [/*#__PURE__*/_jsx("div", {
            className: "kc-ui-colm-title",
            children: title ? /*#__PURE__*/_jsx("h4", {
              children: /*#__PURE__*/_jsx(TranslateText, {
                id: title
              })
            }) : null
          }), showHintMessage && /*#__PURE__*/_jsx("div", {
            className: "kc-ui-trendhintmessage-div",
            children: /*#__PURE__*/_jsx(HintMessage, {
              hintMessage: hintMessage
            })
          }), dateFilter && /*#__PURE__*/_jsx(DateFilter, {
            title: dateFilterTitle,
            options: dateFilterOptions,
            value: dateFilterValue,
            onTriggerChange: onTriggerDateFilterChange,
            dateFormat: dateFilterDateFormat
          })]
        }), loader ? /*#__PURE__*/_jsx(Loader, {
          loader: loader
        }) : /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            children: value?.label && /*#__PURE__*/_jsxs("div", {
              className: "kc-ui-trend-label kc-ui-trend-colm kc-ui-flex",
              children: [/*#__PURE__*/_jsx("div", {
                className: "kc-ui-trend-value",
                children: /*#__PURE__*/_jsx("div", {
                  dangerouslySetInnerHTML: {
                    __html: value?.label
                  }
                })
              }), /*#__PURE__*/_jsxs("div", {
                className: `kc-ui-trend-time ${trendValue === '' ? 'kc-ui-trend-time-align' : ''}`,
                children: [trendValue === '' ? null : /*#__PURE__*/_jsx("div", {
                  className: `kc-ui-trend-val-${trendValue}`
                }), text || ""]
              })]
            })
          }), previousValue?.label && dateFilterValue?.value !== DropdownValue.Custom && /*#__PURE__*/_jsx("div", {
            className: "kc-ui-trend-prev kc-ui-trend-colm",
            children: /*#__PURE__*/_jsx("div", {
              className: "kc-ui-trend-date",
              dangerouslySetInnerHTML: {
                __html: intl.formatMessage({
                  id: previousValue?.label
                }, previousValue.translationValues)
              }
            })
          }), message && /*#__PURE__*/_jsx("div", {
            className: "kc-ui-trend-message kc-ui-trend-colm",
            children: /*#__PURE__*/_jsx("div", {
              className: `${message.type === 1 ? 'kc-ui-danger' : message.type === 2 ? "kc-ui-warning" : ""}`,
              children: /*#__PURE__*/_jsx(TranslateText, {
                id: message.label
              })
            })
          }), chartData?.length ? /*#__PURE__*/_jsx("div", {
            className: "kc-ui-trend-message kc-ui-trend-colm",
            children: /*#__PURE__*/_jsx(XYLineChartWidget, {
              chartData: chartData,
              legend: legend,
              intl: intl
            })
          }) : null, !value && !previousValue && !text && !message && /*#__PURE__*/_jsx("div", {
            className: "kc-ui-noresult-div",
            children: /*#__PURE__*/_jsx("span", {
              children: /*#__PURE__*/_jsx(TranslateText, {
                id: noValueText
              })
            })
          })]
        })]
      })
    })
  });
};
// Prop type defination for compile ime

// Default props
_TrendWidget.defaultProps = {
  loader: false,
  title: "",
  value: {},
  previousValue: {},
  text: "",
  dateFilterTitle: '',
  dateFilter: false,
  dateFilterOptions: [],
  onTriggerDateFilterChange: () => {},
  dateFilterValue: {},
  dateFilterDateFormat: "MM/dd/yyyy",
  message: {},
  noValueText: "No Results",
  width: "100%",
  disabled: false,
  chartData: [],
  legend: {}
};
export const TrendWidget = injectIntl( /*#__PURE__*/React.memo(_TrendWidget));